import React from 'react';
import { FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { useWaiverTemplates } from '../../../hooks/waivers/useWaiverTemplates';
import DefaultWaiverTemplatesSeederDialog from '../forms/DefaultWaiverTemplatesSeederDialog';

export default function WaiverTemplateSelect ({ onSelect }) {
    const [seederDialogOpen, setSeederDialogOpen] =  React.useState(false);
    const [listTrigger, setListTrigger] = React.useState(false);
    const toggleListTrigger = () => {
        setListTrigger(prev => !prev);
    };

    const onEmptyData = () => {
        setSeederDialogOpen(true);
    };

    const { waiverTemplates, loading, setWaiverTemplates } = useWaiverTemplates(listTrigger, onEmptyData);

    const handleChange = (e) => {
      onSelect(e.target.value);
    };

    return (
        <React.Fragment>
          <FormControl fullWidth>
            <InputLabel>
              Load Template
            </InputLabel>
            <Select
              value=""
              label="Load Template"
              onChange={handleChange}
              MenuProps={{
                PaperProps: {
                  style: {
                    maxHeight: 250, // adjust as needed
                  },
                },
              }}
            >
              {!loading && waiverTemplates?.map((waiverTemplate) => (
                <MenuItem 
                  value={{ 
                    name: waiverTemplate.name, 
                    content: waiverTemplate.content 
                  }} 
                  sx={{ my: 1 }}>
                    {waiverTemplate.name}
                  </MenuItem>
              ))}
            </Select>
          </FormControl>
          <DefaultWaiverTemplatesSeederDialog
            open={seederDialogOpen}
            setOpen={setSeederDialogOpen} 
            successCallback={toggleListTrigger}
        />
        </React.Fragment>
    );
}